import { Controller } from "@hotwired/stimulus";
import moment from 'moment';

export default class extends Controller {
  static targets = ["table"];

  connect() {
    if (!this.hasTableTarget) return;

    $(this.tableTarget).DataTable({
      responsive: true,
      retrieve: true,
      autoWidth: false,
      processing: true,
      serverSide: true,
      paging: true,
      pageLength: 100,
      order: [[9, 'desc']],
      lengthMenu: [
        [50, 100, 250, 500],
        ["50 rows", "100 rows", "250 rows", "500 rows"],
      ],
      ajax: {
        url: $(this.tableTarget).data("source"),
      },
      columns: [
        { data: 'id' },
        { data: 'user_email' },
        { data: 'status' },
        { data: 'sub_total' },
        { data: 'tax_total' },
        { data: 'fee_total' },
        { data: 'grand_total' },
        { data: 'payment_id' },
        { data: 'payment_method' },
        {
          data: 'transaction_date', // Assuming this corresponds to the transaction date column
          render: function(data, type, row) {
            if (data) {
              if (type === 'display' || type === 'filter') {
                // Return the date in its original "November 12, 2024 03:38" format for display purposes
                return data;
              } else if (type === 'sort' || type === 'type') {
                // Parse the date using Moment.js and return the timestamp for sorting
                return moment(data, 'MMMM DD, YYYY HH:mm').valueOf();
              }
            }
            return ''; // Return empty string for missing dates
          }
        },
        { data: 'actions' }
      ],
      // dom: "Blfrtip",
      // buttons: [
      //   {
      //     text: "Export All",
      //     action: function (e, dt, node, config) {
      //       window.location.href = "/admin/analytics/export_all.csv";
      //     },
      //   },
      //   {
      //     extend: "copyHtml5",
      //     text: '<i class="fas fa-copy"></i> Copy',
      //     titleAttr: "Copy",
      //   },
      //   {
      //     extend: "print",
      //     text: '<i class="fas fa-print"></i> Print',
      //     titleAttr: "Print",
      //     title: "orders-table-" + Date.now(),
      //     exportOptions: {
      //       modifier: {
      //         selected: null,
      //       },
      //     },
      //   },
      //   {
      //     extend: "csvHtml5",
      //     text: '<i class="fas fa-table"></i> CSV',
      //     titleAttr: "CSV",
      //     title: "orders-table-" + Date.now(),
      //     exportOptions: {
      //       modifier: {
      //         selected: null,
      //       },
      //     },
      //   },
      // ],
      language: {
        search: '<i class="fa fa-search"></i>',
        searchPlaceholder: "SEARCH BY EMAIL",
      },
    });
  }
}
